import { lazy, Suspense } from "react";

const ScreenManager = lazy(() => {
  if (import.meta.env.DEV || (typeof window !== "undefined" && (window as { __ACUL_PREVIEW_MODE__?: boolean }).__ACUL_PREVIEW_MODE__)) {
    return import("./DevScreenManager");
  }
  return import("./ProdScreenManager");
});

function NoContextFallback() {
  return (
    <div className="acul-fallback" style={{ maxWidth: "480px", margin: "2rem auto", padding: "2rem", textAlign: "center" }}>
      <p style={{ marginBottom: "1rem" }}>
        This app runs inside Auth0 Universal Login. Visiting the CDN directly has no login context.
      </p>
      <p style={{ marginBottom: "1rem", fontSize: "0.9375rem", color: "var(--acul-text-muted, #a0aec0)" }}>
        Add <code style={{ padding: "0.2em 0.4em", background: "#2d313c", borderRadius: "4px" }}>?preview=1</code> to preview screens, or sign in through your app.
      </p>
    </div>
  );
}

export default function App() {
  const noContext = typeof window !== "undefined" && (window as { __ACUL_NO_CONTEXT__?: boolean }).__ACUL_NO_CONTEXT__;
  if (noContext) {
    return <NoContextFallback />;
  }
  return (
    <Suspense fallback={<div className="acul-loading">Loading...</div>}>
      <ScreenManager />
    </Suspense>
  );
}
